import { useContext } from 'react';
import { NavContext } from '../context/NavContext';

export const useNavContext = () => {
  return useContext(NavContext);
};
